import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getNavbarSubpageHref } from './navbarLinks';

const NavbarMobileMenu = ({ data, colors = [], onItemClick }) => {
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    return (
        <div className="anikino__mobile-menu">
            {data.map((page, index) => {
                const visibleSubpages = Array.isArray(page.subpages)
                    ? page.subpages.filter((subpage) => subpage !== '__NONE__')
                    : [];
                return (
                    <React.Fragment key={page.path || index}>
                        {visibleSubpages.length > 1 ? (
                            <details
                                className={`anikino__mobile-menu-item ${colors[(index + 3) % colors.length] || ''}`}
                            >
                                <summary className="anikino__mobile-menu-summary">
                                    <p className="anikino__mobile-menu-title">{page.pl}</p>
                                </summary>
                                <ul className="anikino__mobile-menu-submenu">
                                    {visibleSubpages.map((subpage, id) => (
                                        <li
                                            className="anikino__mobile-menu-submenu-item"
                                            key={`${page.path}-${subpage.path || id}`}
                                        >
                                            <Link
                                                to={getNavbarSubpageHref(page, subpage)}
                                                onClick={onItemClick}
                                            >
                                                {subpage.pl}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </details>
                        ) : visibleSubpages.length === 1 ? (
                            <Link
                                className={`anikino__mobile-menu-item ${colors[(index + 3) % colors.length] || ''}`}
                                to={getNavbarSubpageHref(page, visibleSubpages[0])}
                                onClick={onItemClick}
                            >
                                <p className="anikino__mobile-menu-summary">{page.pl}</p>
                            </Link>
                        ) : (
                            <p className="anikino__mobile-menu-title">{page.pl}</p>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

NavbarMobileMenu.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    colors: PropTypes.arrayOf(PropTypes.string),
    onItemClick: PropTypes.func,
};

export default NavbarMobileMenu;
